import globalAxios from "@/api/GlobalAxios";

const upload = async (formData) => {
  // const config = {
  //   headers: { 'Content-Type': 'multipart/form-data' },
  // };
  const res = await globalAxios.post(`/api/upload`, formData);
  return res;
};

const uploadoption = async () => {
  const res = await globalAxios.get();
  return res.data;
};

const initiateMultipartUpload = async (fileName) => {
  const res = await globalAxios.post(`/api/upload/initiate-multipart-upload`, {
    key: fileName
  });
  return res.data;
};

const getPresignedUrl = async (key, uploadId, partNumber) => {
  const res = await globalAxios.post(`/api/upload/get-presigned-url`, {
    key,
    uploadId,
    partNumber
  });
  return res.data.presignedUrl;
};

const completeMultipartUpload = async (key, uploadId, parts, name) => {
  const res = await globalAxios.post(`/api/upload/complete-multipart-upload`, {
    key,
    uploadId,
    parts,
    name
  });
  return res.data;
};


export default {
  upload,
  uploadoption,
  initiateMultipartUpload,
  getPresignedUrl,
  completeMultipartUpload
};